import { useState } from "react";
import { Controller } from "react-hook-form";
import { Row, Col, Button, Form } from "react-bootstrap";
import { Select } from "../../../common/select/Select";
import { Input } from "../../../common/input/Input";
import { AsyncPaginate } from "react-select-async-paginate";
import styles from "./sections.module.css";
export const OrderDetailsSection = ({
  control,
  register,
  errors,
  orderFields,
  loadProductOptions,
  productLabels,
  setProductLabels,
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#fff",
      borderColor: "#9e9e9e",
      boxShadow: state.isFocused ? "0 0 0 1px #9e9e9e" : "none",
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#fff",
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      backgroundColor: "#fff",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f5f5f5" : "#fff",
      color: "#000",
      cursor: "pointer",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#000",
    }),

    input: (base) => ({
      ...base,
      color: "#000",
    }),
  };
  const [removingIndex, setRemovingIndex] = useState(null);
  const handleRemove = (index) => {
    setRemovingIndex(index);
    setTimeout(() => {
      orderFields.remove(index);
      setRemovingIndex(null);
    }, 1000); // match animation duration
  };
  return (
    <div>
      {orderFields.fields.length > 0 && (
        <h4>
          <span>Order </span>
          Details
        </h4>
      )}
      {errors?.orderDetailsRequestDtos?.message && (
        <p className="text-danger">{errors.orderDetailsRequestDtos.message}</p>
      )}
      {orderFields.fields.map((item, index) => (
        <div
          key={item.id}
          className={`align-items-end animate__animated ${
            removingIndex === index
              ? "animate__zoomOutRight"
              : "animate__flipInX"
          }`}
        >
          <h5 className="mt-3 mb-1">Item #{index + 1}</h5> {/* Number label */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3" style={{ position: "relative" }}>
                <Form.Label>Product</Form.Label>
                <Controller
                  control={control}
                  name={`orderDetailsRequestDtos.${index}.productId`}
                  render={({ field }) => (
                    <AsyncPaginate
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={customStyles}
                      value={
                        field.value
                          ? {
                              value: field.value,
                              label: productLabels[field.value]
                                ? `${productLabels[field.value].label}`
                                : "Loading...",
                            }
                          : null
                      }
                      loadOptions={loadProductOptions}
                      onChange={(option) => {
                        field.onChange(option?.value);
                        setProductLabels((prev) => ({
                          ...prev,
                          [option?.value]: {
                            label: option?.label,
                            price: option?.price,
                          },
                        }));
                      }}
                      additional={{ page: 1 }}
                      isClearable
                      placeholder="Select Product"
                    />
                  )}
                />
                {errors?.orderDetailsRequestDtos?.[index]?.productId && (
                  <p
                    className="text-danger mb-0 animate__animated animate__headShake"
                    style={{
                      position: "absolute",
                      bottom: -20,
                      left: 0,
                      fontSize: "0.875rem",
                    }}
                  >
                    {errors.orderDetailsRequestDtos[index].productId.message}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col md={3}>
              <Input
                label="Quantity"
                field={`orderDetailsRequestDtos.${index}.quantity`}
                register={register}
                errors={errors}
                type="number"
              />
            </Col>

            <Col md={3}>
              <Select
                label="VAT Category"
                field={`orderDetailsRequestDtos.${index}.vatCategory`}
                register={register}
                errors={errors}
                options={["A", "B", "C", "D"].map((c) => ({
                  value: c,
                  label: c,
                }))}
              />
            </Col>

            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>&nbsp;</Form.Label>
                <Button
                  variant="outline-danger"
                  onClick={() => handleRemove(index)}
                  disabled={removingIndex === index}
                  className="w-100"
                >
                  Remove
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}

      <Row>
        <Col md={{ span: 2, offset: 10 }}>
          <Button
            className="w-100"
            variant="outline-warning"
            onClick={() =>
              orderFields.append({
                productId: "",
                quantity: 1,
                vatCategory: "A",
              })
            }
          >
            Add Product
          </Button>
        </Col>
      </Row>
    </div>
  );
};
